import React from 'react'
import colors from '@constants/colors'
import { SubmitBtn } from '@appearance/styled'

const palette = {
    normal: {
        backgroundColor: colors.COLOR_PRIMARY,
        color: colors.APP_WHITE,
    },
    dark: {
        backgroundColor: colors.APP_BLACK,
        color: colors.APP_WHITE,
    },
    white: {
        backgroundColor: colors.APP_WHITE,
        color: colors.COLOR_PRIMARY,
    },
}

export default ({
    onClick,
    label,
    disabled,
    theme = 'normal',
    backgroundColor,
}) => {
    return (
        <SubmitBtn
            onClick={onClick}
            disabled={disabled}
            color={palette[theme].color}
            backgroundColor={
                backgroundColor
                    ? backgroundColor
                    : palette[theme].backgroundColor
            }
        >
            {label}
        </SubmitBtn>
    )
}
